
(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('CreateNpqOrPsychDialogController', CreateNpqOrPsychDialogController);

    CreateNpqOrPsychDialogController.$inject = ['$stateParams', 'ipmConstants', '$uibModalInstance','entity', 'requestType', 'PsychIntakeService', 'NPQQuestionnaireService', 'PatientService', 'PatientAgreementsService', 'HaqsBatteryService', '$q', 'AlertService'];

    function CreateNpqOrPsychDialogController($stateParams, constants, $uibModalInstance, entity, requestType, PsychIntakeService, NPQQuestionnaireService, PatientService, PatientAgreementsService, HaqsBatteryService, $q, AlertService) {
        var vm = this;

        vm.type = requestType;
        vm.requestEntity = entity;
        vm.requestEntity.patientId = null;
        vm.isSaving = false;
        vm.patientCases = [];
        vm.patientCaseSelect = null;
        vm.patientCaseNoCaseNumber = {id: null, caseNumber: "No Case Number"};
        vm.predicate = 'id';
        vm.pageSize = 20;
        vm.patientId = $stateParams.id;

        vm.clear = clear;
        vm.clearSelectedCase = clearSelectedCase;
        vm.save = save;
        vm.searchPatientCase = searchPatientCase;
        vm.agreements = [];
        vm.agreementSeleted = null;
        vm.invalidAgreementCount = 0;
        vm.batteries = [];
        vm.batterySeleted = null;
        vm.isInvalidBattery = false;

        init();

        function init() {
			searchPatientCase();
            getAgreements();
            getBatteries();
        }

        function getAgreements() {
            vm.isLoading = true;
            PatientAgreementsService.getAllAgreementForSelect(vm.patientId, constants.SEND_NEW_AGREEMENT).then(function (response) {
                vm.agreements = response ? response : [];
                defaultSelectedAgreements();
                vm.isLoading = false;
            });
        }

        function getBatteries() {
            vm.isLoading = true;

            HaqsBatteryService.getAllBatteryForSelect(constants.DROPDOWN_BATTERIES_TYPE, vm.patientId).then(function (response) {
                vm.batteries = response ? response : [];
                vm.isLoading = false;
            });
        }

        function defaultSelectedAgreements() {
			vm.agreementSeleted = _.filter(vm.agreements, function(o) { return o.isDefault });
			checkSelectedAgreements();
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function clearSelectedCase () {
            vm.patientCaseSelect = null;
            defaultSelectedAgreements();
            vm.batterySeleted = null;
        }

        function save(){
			vm.requestEntity.patientId = $stateParams.id;
            vm.requestEntity.patientCase = vm.patientCaseSelect ? vm.patientCaseSelect : null;

			if (vm.isSaving || !vm.requestEntity.patientId || !vm.requestEntity.patientCase) {
                return;
            }
            vm.isSaving = true;

            vm.requestEntity.agreements = vm.agreementSeleted ? vm.agreementSeleted : null;
            vm.requestEntity.batteries = vm.batterySeleted ? vm.batterySeleted : null;

            if (vm.type === 'PSYCH') {
                PsychIntakeService.savePsychIntakeForm(vm.requestEntity).then(function(res) {
                    onSaveSuccess(res);
                }, function errorSave(error) {
                    onSaveError(error);
                });
            } else if (vm.type === 'NPQ') {
				NPQQuestionnaireService.saveNPQQuestionnaire(vm.requestEntity).then(function(res) {
                    onSaveSuccess(res);
                }, function errorSave(error) {
                    onSaveError(error);
                });
		    }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close({requestType: vm.type});
        }

        function onSaveError (error) {
            vm.isSaving = false;
            var errorMessage = error.headers('X-ipmApp-error-message');
            if(error.status === 400 ) {
                if (errorMessage === 'notAllowCreateQuestionnaire' || errorMessage === 'notAllowCreatePsychIntakeForm'){
                    $uibModalInstance.close({requestType: vm.type, notAllowCreate:true});
                }
            } else if (error.status !== 200) {
                if (vm.type === 'PSYCH') {
                    AlertService.error("An error occurred while creating the Psych Intake Form. Please try again");
                } else if (vm.type === 'NPQ') {
                    AlertService.error("An error occurred while creating the New Patient Questionnaires. Please try again");
                }
               $uibModalInstance.dismiss(error);
           }
        }

        function sort() {
            var result = [vm.predicate + ',desc'];
            return result;
        }

        function searchPatientCase($item) {
            vm.searchText = $item ? $item : '';
            var pageable = {
                page: 0,
                size: vm.pageSize,
                sort: sort()
            };
            return $q(function (resolve, reject) {
                PatientService.searchPatientCase(vm.patientId, vm.searchText, false, pageable)
                    .then(function (response) {
                        if (response && response.length > 0) {
                            resolve(response);
                            vm.patientCases = response;
                            vm.patientCases.unshift(vm.patientCaseNoCaseNumber);
                        } else {
                            vm.patientCases.push(vm.patientCaseNoCaseNumber);
                            resolve([]);
                        }
                    }, function () {
                        reject([]);
                    });
            });
        }

        vm.checkDisableSave = function () {
            return !vm.patientCaseSelect || !vm.patientCaseSelect.caseNumber;
        };

        vm.searchTextOnChange = function () {
        };

        vm.notYetSelectedCase = function () {
            return !vm.patientCaseSelect || !vm.patientCaseSelect.caseNumber;
        };

        vm.selectBatteriesOnChange = function () {
			if (!vm.batterySeleted || vm.batterySeleted.length === 0) {
		        vm.isInvalidBattery = false;
		        return;
		    }
		    var hasInvalid = vm.batterySeleted.some(function (battery) {
		        return battery.batteryTestCnt < 1;
		    });
		    vm.isInvalidBattery = hasInvalid;
        };

        vm.selectAgreementsOnChange = function () {
			checkSelectedAgreements();
        }

        function checkSelectedAgreements() {
			if (!vm.agreementSeleted || vm.agreementSeleted.length === 0) {
		        vm.invalidAgreementCount = 0;
		        return;
		    }
            vm.invalidAgreementCount = vm.agreementSeleted.filter(function (agreement) {
                return agreement.existedAndAllCompleted === true;
            }).length;
        }
    }
})();
